/// <amd-module name="Build/Designer/WarningBanner" />

import { GlobalMessageLevel, IGlobalMessageLink, IGlobalMessagesService } from "TFS/GlobalBanner/GlobalMessagesService";

import { IVssPageContext } from "VSS/Platform/Context";

export interface BannerContent {
    id: string,
    messageFormat: string,
    links: IGlobalMessageLink[]
}

export function clearWarning(pageContext: IVssPageContext, bannerId: string) {
    const globalMessageService = pageContext.getService<IGlobalMessagesService>("IGlobalMessagesService");
        const currentBanner = globalMessageService.getBanner();
        if (currentBanner && currentBanner.settingId === bannerId) {
            globalMessageService.closeBanner();
        }
}

export function showWarning(pageContext: IVssPageContext, banner: BannerContent) {
    const globalMessageService = pageContext.getService<IGlobalMessagesService>("IGlobalMessagesService");
        globalMessageService.addBanner({
            messageFormat: banner.messageFormat,
            messageLinks: banner.links,
            level: GlobalMessageLevel.warning,
            settingId: banner.id
        }, false, false);
}